"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeaknessEffectHandler = exports.WeaknessEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class WeaknessEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.Weakness;
        this.__typeName = "Weakness";
        this.name = "Weakness";
        this.harmful = true;
    }
}
exports.WeaknessEffectArgs = WeaknessEffectArgs;
let WeaknessEffectHandler = class WeaknessEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyDebuffs({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    effect: new _1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Vitality, container.getPercentOfBaseAttributeScore(state.targetId, 10, "Vitality")),
                    duration: Duration_1.Duration.Permanent,
                },
                {
                    effect: new _1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.Toughness, container.getPercentOfBaseAttributeScore(state.targetId, 10, "Toughness")),
                    duration: Duration_1.Duration.Permanent,
                }
            ]
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
WeaknessEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.Weakness)
], WeaknessEffectHandler);
exports.WeaknessEffectHandler = WeaknessEffectHandler;
